import { PageEnvironment } from "../types/analytics-events";
import { findLocationByName } from "../utils/locations";
import { createHash } from "crypto";

var getHashedUserIdFromJwt = function getHashedUserIdFromJwt(jwt) {
  var customerUuid = JSON.parse(window.atob(jwt.split('.')[1])).uuid;
  return createHash('sha256').update(customerUuid).digest('hex');
};

export var buildEventBase = function buildEventBase(options) {
  var userId = options.jwt ? getHashedUserIdFromJwt(options.jwt) : undefined;
  return {
    country: options.country.toUpperCase(),
    language: options.language,
    location: options.cityName,
    environment: location.host === "www.share-now.com" ? PageEnvironment.prod : PageEnvironment.int,
    legal_entity: findLocationByName(options.cityName).legalEntityId,
    page_location: location.href,
    page_title: document.title !== "" ? document.title : undefined,
    page_path: location.pathname,
    page_referrer: document.referrer !== "" ? document.referrer : undefined,
    page_query_parameter: location.search !== "" ? location.search : undefined,
    page_platform: options.pagePlatform,
    user_id: userId
  };
};
export var buildPageviewEvent = function buildPageviewEvent(options) {
  return Object.assign(Object.assign({}, buildEventBase(options)), {
    event: "pageview"
  });
};